import { render, staticRenderFns } from "./default.vue?vue&type=template&id=5e1fa036&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TheCartExerpt: require('/opt/build/repo/components/TheCartExerpt.vue').default,TheHeader: require('/opt/build/repo/components/TheHeader.vue').default,TheFooter: require('/opt/build/repo/components/TheFooter.vue').default})
